import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type AlignType, type AlignBreakpointType, alignList } from '../../typings/alignType';
import { BreakpointDepended } from '../breakpointDepended';
import { defaults } from '../defaults';

export function withAlignProps(defaultValue?: string) {
  return {
    /**
     * Alignment elementu (flex)
     */
    align: {
      type: [String, Object] as PropType<AlignType | AlignBreakpointType>,
      default: defaultValue
    }
  };
}

/**
 * Zwraca klasy align (flex)
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withSizeProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useAlignProps = (prefix: string, props: ExtractPropTypes<ReturnType<typeof withAlignProps>>) => {
  return computed(() => {
    if (typeof props.align === 'string') {
      return `${prefix}--align-${props.align}`;
    }
    if (BreakpointDepended(props.align).value) {
      return `${prefix}--align-${BreakpointDepended(props.align).value}`;
    }
    return;
  });
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesAlignArgs = {
  args: {
    align: defaults.flex.align
  },

  argTypes: {
    align: {
      options: alignList,
      control: { type: 'select' }
    }
  }
};
